module.exports = __webpack_public_path__ + "img/lg_ring_y_e_0_0@2x.b60f3f58.png";